var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "m-5 md:m-15 2xl:m-20"
  }, [_c('EvalInProgress', {
    attrs: {
      "evaluation-in-progress": _vm.evaluationInProgress
    },
    on: {
      "massAssignation": function ($event) {
        return _vm.displayAssignTemplate();
      },
      "showPreview": function ($event) {
        _vm.showPreview = true;
      }
    }
  }), _vm._v(" "), _c('mass-template-assignation', {
    attrs: {
      "opened": _vm.massAssignation,
      "template": _vm.massAssignationTemplate
    },
    on: {
      "close": function ($event) {
        _vm.massAssignation = false;
      }
    }
  }), _vm._v(" "), _c('popup', {
    attrs: {
      "opened": _vm.confirmDeleteTemplate > -1
    },
    on: {
      "close": function ($event) {
        _vm.confirmDeleteTemplate = -1;
      }
    }
  }, [_vm.confirmDeleteTemplate == 0 ? _c('div', [_c('div', {
    staticClass: "my-5 xl:my-15"
  }, [_c('h3', {
    staticClass: "mb-5 md:mb-10 2xl:mb-15"
  }, [_vm._v("\n          Supprimer le modèle de page \"" + _vm._s(_vm.templateNameToDelete) + "\"\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n            Êtes-vous sûr de vouloir supprimer le modèle de page \"" + _vm._s(_vm.templateNameToDelete) + "\" ?\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n            Cette suppression sera définitive et irrévocable.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center bg-pink"
  }, [_c('action-button', {
    staticClass: "mr-4",
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-300",
      "libelle": "ANNULER"
    },
    on: {
      "clickAction": function ($event) {
        _vm.confirmDeleteTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "SUPPRIMER",
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": _vm.confirm_delete_template
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _vm.confirmDeleteTemplate == 1 ? _c('div', [_c('h3', {
    staticClass: "w-full text-indigo-600 mt-12 mb-10"
  }, [_vm._v("\n        Le modèle de page \"" + _vm._s(_vm.templateNameToDelete) + "\""), _c('br'), _vm._v("a bien été\n        supprimé !\n      ")]), _vm._v(" "), _c('illustration', {
    staticClass: "w-full m-5",
    attrs: {
      "name": "basket"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.confirmDeleteTemplate == 2 ? _c('div', [_c('div', {
    staticClass: "my-5 xl:my-15"
  }, [_c('h3', {
    staticClass: "mb-5 md:mb-10 2xl:mb-15"
  }, [_vm._v("\n          Supprimer le modèle de page \"" + _vm._s(_vm.templateNameToDelete) + "\"\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-5"
  }, [_c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n            Êtes-vous sûr de vouloir supprimer le modèle de page \"" + _vm._s(_vm.templateNameToDelete) + "\" ?\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indigo-600 text-lg text-center"
  }, [_vm._v("\n            Cette suppression sera définitive et irrévocable.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "mb-10"
  }, [_c('p', {
    staticClass: "text-pink-600 text-lg text-center"
  }, [_vm._v("\n            Attention, ce modèle de page est utilisé par\n            " + _vm._s(_vm.listAssignedUsersTemplate.length) + " bénéficiaire"), _vm.listAssignedUsersTemplate.length > 1 ? _c('span', [_vm._v("s")]) : _vm._e(), _vm._v("\n            :\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "text-pink-600 text-lg text-center"
  }, _vm._l(_vm.listAssignedUsersTemplate, function (beneficiary, index) {
    return _c('span', {
      key: beneficiary.id
    }, [index > 0 ? _c('span', [_vm._v("- ")]) : _vm._e(), _vm._v(_vm._s(beneficiary.firstname) + "\n              "), _c('span', {
      staticClass: "uppercase"
    }, [_vm._v(_vm._s(beneficiary.lastname))])]);
  }), 0), _vm._v(" "), _c('p', {
    staticClass: "text-pink-600 text-lg text-center"
  }, [_vm._v("\n            En cas de suppression, le modèle de page \"" + _vm._s(_vm.templatePageToAssignAfterDelete.name) + "\" leur sera attribué.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center bg-pink"
  }, [_c('action-button', {
    staticClass: "mr-4",
    attrs: {
      "border-color": "border-pink-600",
      "text-color": "text-pink-600",
      "bg-color": "bg-pink-300",
      "libelle": "ANNULER"
    },
    on: {
      "clickAction": function ($event) {
        _vm.confirmDeleteTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('action-button', {
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-pink-600",
      "libelle": "SUPPRIMER",
      "type-shadow": "shadow-pink"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.confirm_delete_template(_vm.templatePageToAssignAfterDelete);
      }
    }
  })], 1)])]) : _vm._e()]), _vm._v(" "), _c('deactivate-template-popup', {
    attrs: {
      "confirm-deactivate-template": _vm.confirmDeactivateTemplate,
      "template-name-to-deactivate": _vm.templateNameToDeactivate,
      "list-assigned-users-template": _vm.listAssignedUsersTemplate,
      "template-page-to-assign-after-delete": _vm.templatePageToAssignAfterDelete
    },
    on: {
      "confirm_deactivate_template": function (templatePageToAssignAfterDelete) {
        _vm.confirm_deactivate_template(templatePageToAssignAfterDelete);
      },
      "close": function ($event) {
        _vm.confirmDeactivateTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('activate-template-popup', {
    attrs: {
      "confirm-activate-template": _vm.confirmActivateTemplate,
      "template-name-to-deactivate": _vm.templateNameToDeactivate
    },
    on: {
      "confirm_activate_template": function ($event) {
        return _vm.confirm_activate_template();
      },
      "close": function ($event) {
        _vm.confirmActivateTemplate = -1;
      }
    }
  }), _vm._v(" "), _c('popup', {
    attrs: {
      "opened": _vm.showPreview
    },
    on: {
      "close": function ($event) {
        _vm.showPreview = false;
      }
    }
  }, [_c('div', {
    staticClass: "m-5 xl:m-15 2xl:m-20 w-auto h-auto"
  }, [_c('h3', {
    staticClass: "mb-15"
  }, [_vm._v("\n        " + _vm._s(_vm.infosPage.libelle_template) + "\n      ")]), _vm._v(" "), _vm._l(_vm.template, function (domaine, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "grid grid-cols-12 mb-15"
    }, [_c('div', {
      staticClass: "col-span-full text-indigo-600 uppercase text-base font-normal"
    }, [_vm._v("\n            " + _vm._s(domaine[0].libelle) + "\n          ")]), _vm._v(" "), _c('div', {
      staticClass: "col-span-full grid grid-cols-12 gap-4"
    }, _vm._l(domaine, function (field, jndex) {
      return _c('div', {
        key: jndex,
        staticClass: "col-span-full",
        class: jndex == 0 ? 'display-none' : domaine.length > 2 ? 'lg:col-span-4' : 'lg:col-span-6'
      }, [jndex !== 0 && field.type == 'text' ? _c('input-text', {
        attrs: {
          "libelle": field.libelle
        }
      }) : _vm._e(), _vm._v(" "), jndex !== 0 && field.type == 'multi' ? _c('input-select', {
        attrs: {
          "name": field.libelle.toLowerCase().replace(' ', '_').replace('\'', '') + index + jndex,
          "libelle": field.libelle,
          "datas": field.criterions
        }
      }) : _vm._e(), _vm._v(" "), field.type == 'text-area' ? _c('input-text-area', {
        attrs: {
          "size": "5",
          "name": field.libelle.toLowerCase().replace(' ', '_').replace('\'', ''),
          "libelle": field.libelle
        }
      }) : _vm._e()], 1);
    }), 0)])]);
  })], 2)]), _vm._v(" "), _vm.isEditable ? _c('div', [_c('div', {
    staticClass: "flex justify-center"
  }, [_c('input-title', {
    staticClass: "mb-5 md:mb-15 2xl:mb-20 w-3/4",
    attrs: {
      "name": "title",
      "value": _vm.infosPage.libelle_template,
      "disabled": !_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) || this.evaluationInProgress,
      "error": true,
      "maxlength": 40
    },
    on: {
      "input": function (value) {
        _vm.infosPage.libelle_template = value;
      },
      "valid": function (title) {
        _vm.SET_NAME_TEMPLATE_IN_LIST([_vm.infosPage.id_template, title]);
      }
    }
  })], 1), _vm._v(" "), _c('list-buttons', {
    attrs: {
      "evaluation-in-progress": _vm.evaluationInProgress,
      "is-active": _vm.infosPage.is_active,
      "can-delete": ""
    },
    on: {
      "preview": function () {
        _vm.showPreview = true;
      },
      "deactivateTemplate": function ($event) {
        return _vm.displayConfirmDeactivateTemplate();
      },
      "activateTemplate": function ($event) {
        return _vm.displayConfirmActivateTemplate();
      },
      "confirmDelete": function () {
        _vm.displayConfirmDeleteTemplate();
      },
      "assignTemplate": function ($event) {
        return _vm.displayAssignTemplate();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('div', {
    staticClass: "flex flex-row self-center relative justify-end items-center cursor-pointer my-8 w-max-content w-max",
    on: {
      "click": [_vm.displayFieldList, function ($event) {
        $event.stopPropagation();
      }]
    }
  }, [_c('div', {
    staticClass: "flex flex-row ml-auto items-end"
  }, [(_vm.template || []).length > 0 ? _c('h3', {
    staticClass: "text-xl text-indigo-600"
  }, [_vm._v("\n            " + _vm._s('Domaine ' + (_vm.currentField + 1) + '. ' + _vm.template[_vm.currentField][0].libelle) + "\n          ")]) : _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) ? _c('h3', {
    staticClass: "text-xl text-indigo-600",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.addDomaine();
      }
    }
  }, [_vm._v("\n            Ajouter un domaine\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-pink-600 max-h-8 mr-auto rounded-full relative inline-flex items-center p-2 order-2"
  }, [_vm.template.length > 0 ? _c('icon', {
    staticClass: "h-4 w-4",
    attrs: {
      "name": "chevron-down"
    }
  }) : _vm._e()], 1), _vm._v(" "), _vm.showList ? _c('div', {
    directives: [{
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.displayFieldList,
      expression: "displayFieldList"
    }],
    staticClass: "fieldlist z-20 w-max-content w-max mt-2 absolute rounded-md bg-white flex transform translate-y-full self-end shadow-md shadow-gray-600 text-sm"
  }, [_c('div', {
    staticClass: "mx-5 my-3"
  }, [_c('div', {
    staticClass: "text-left"
  }, [_vm._l(_vm.template, function (field, i) {
    return _c('div', {
      key: i,
      staticClass: "first:pt-2 py-1"
    }, [_c('p', {
      staticClass: "text-gray-600 hover:text-gray-900",
      on: {
        "click": function ($event) {
          _vm.currentField = i;
        }
      }
    }, [_c('span', [_vm._v(_vm._s('Domaine ' + (i + 1) + ' : ' + field[0].libelle))])])]);
  }), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) ? _c('div', {
    staticClass: "text-gray-600 hover:text-gray-900 pt-3"
  }, [_c('span', {
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.addDomaine();
      }
    }
  }, [_vm._v(" Ajouter un domaine ")])]) : _vm._e()], 2)])]) : _vm._e()]), _vm._v(" "), _vm.template.length > 0 ? _c('div', _vm._l(_vm.template[_vm.currentField], function (field, index) {
    return _c('div', {
      key: index,
      staticClass: "grid grid-cols-12 gap-x-4 gap-y-10 place-content-center mb-10"
    }, [_c('div', {
      staticClass: "col-span-full md:col-span-8 flex flex-col md:flex-row items-start md:items-center justify-between content-center"
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [index > 0 && _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) ? _c('div', {
      staticClass: "cursor-pointer mr-4",
      on: {
        "click": function ($event) {
          return _vm.deleteField(index);
        }
      }
    }, [_c('span', {
      staticClass: "minus-button 2xl:h-10 2xl:w-10 2xl:mt-2"
    }, [_c('icon', {
      attrs: {
        "name": "close"
      }
    })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "text-gray-900 text-base uppercase"
    }, [_vm._v("\n                " + _vm._s(index == 0 ? 'Nom du domaine' : 'Champ ' + (index + 1)) + " :\n                " + _vm._s(field.type == 'multi' ? 'Sélection multiple' : field.type == 'text' ? 'Texte' : field.type == 'text-area' ? 'Texte sur plusieurs lignes' : '') + "\n              ")])]), _vm._v(" "), field.type == 'multi' ? _c('checkbox-indigo', {
      attrs: {
        "name": "evaluation",
        "color-libelle": "gray-600",
        "libelle": "Visible dans la cartographie",
        "value": field.display_cartographie,
        "disabled": !_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      },
      on: {
        "input": function (newValue) {
          _vm.$set(field, 'display_cartographie', newValue);
        }
      }
    }) : _vm._e()], 1), _vm._v(" "), field.type == 'text' || field.type == 'text-area' ? _c('div', {
      staticClass: "lg:col-start-1 col-span-full lg:col-span-3"
    }, [_vm.evaluationInProgress ? _c('input-text', {
      attrs: {
        "libelle": index == 0 ? '' : 'Libellé du champ : ' + field.libelle,
        "value": field.libelle,
        "disabled": true
      },
      on: {
        "input": function (newValue) {
          _vm.$set(field, 'libelle', newValue);
        }
      }
    }) : _c('input-text', {
      attrs: {
        "libelle": index == 0 ? '' : 'Libellé du champ : ' + field.libelle,
        "value": field.libelle,
        "disabled": !_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      },
      on: {
        "input": function (newValue) {
          _vm.$set(field, 'libelle', newValue);
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), index == 0 && _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) ? _c('div', {
      staticClass: "lg:col-start-1 col-span-full lg:col-span-3"
    }, [_c('delete-button', {
      attrs: {
        "libelle": "Supprimer le domaine",
        "disabled": !_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      },
      on: {
        "del": function ($event) {
          return _vm.deleteDomaine(_vm.currentField);
        }
      }
    })], 1) : _vm._e(), _vm._v(" "), field.type == 'multi' ? _c('div', {
      staticClass: "col-span-full grid grid-cols-12 gap-x-4 gap-y-10 place-content-center"
    }, [_c('div', {
      staticClass: "lg:col-start-1 col-span-full lg:col-span-3"
    }, [_vm.evaluationInProgress ? _c('input-text', {
      attrs: {
        "libelle": 'Libellé du champ : ' + field.libelle,
        "value": field.libelle,
        "disabled": true
      },
      on: {
        "input": function (newValue) {
          _vm.$set(field, 'libelle', newValue);
        }
      }
    }) : _c('input-text', {
      attrs: {
        "libelle": 'Libellé du champ : ' + field.libelle,
        "value": field.libelle,
        "disabled": !_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER)
      },
      on: {
        "input": function (newValue) {
          _vm.$set(field, 'libelle', newValue);
        }
      }
    })], 1), _vm._v(" "), _c('p', {
      staticClass: "col-start-1 col-span-full text-base text-gray-900 uppercase"
    }, [_vm._v("\n              Critères d'évaluation " + _vm._s(index + 1) + "\n            ")]), _vm._v(" "), _vm._l(field.criterions, function (crit, jndex) {
      return _c('div', {
        key: index.toString() + jndex.toString(),
        staticClass: "col-span-full lg:col-span-3 relative",
        class: {
          '': jndex == 0
        }
      }, [_vm.evaluationInProgress ? _c('input-text', {
        attrs: {
          "name": 'critere_' + index + '_' + jndex,
          "placeholder": 'Critère ' + (jndex + 1),
          "libelle": "",
          "value": crit.value,
          "disabled": true
        }
      }) : _c('input-text', {
        attrs: {
          "name": 'critere_' + index + '_' + jndex,
          "placeholder": 'Critère ' + (jndex + 1),
          "libelle": "",
          "value": crit.value,
          "disabled": !_vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER)
        },
        on: {
          "input": function (newValue) {
            _vm.$set(crit, 'value', newValue);
          }
        }
      }), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) ? _c('div', {
        staticClass: "absolute flex cursor-pointer bottom-8/12 left-11/12 p-2 2xl:p-2.5 items-center text-pink-600 bg-pink-100 border border-pink-600 border-opacity-25 rounded-full",
        on: {
          "click": function ($event) {
            return _vm.deleteCriterion(index, jndex);
          }
        }
      }, [_c('icon', {
        staticClass: "h-2 w-2 2xl:h-2.5 2xl:w-2.5",
        attrs: {
          "name": "close"
        }
      })], 1) : _vm._e()], 1);
    }), _vm._v(" "), _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_EDITER) ? _c('div', {
      staticClass: "col-start-1 col-span-full w-max-content w-max cursor-pointer flex hover:font-medium",
      on: {
        "click": function ($event) {
          return _vm.addCriterion(index);
        }
      }
    }, [_c('span', {
      staticClass: "plus-button 2xl:h-10 2xl:w-10"
    }, [_c('icon', {
      attrs: {
        "name": "plus"
      }
    })], 1), _vm._v(" "), _c('span', {
      staticClass: "text-base text-gray-600 ml-3 mt-1.5 flex-initial"
    }, [_vm._v("\n                Ajouter un critère\n              ")])]) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('hr', {
      staticClass: "col-span-full border-dashed border-gray-600"
    })]);
  }), 0) : _vm._e(), _vm._v(" "), _vm.template.length > 0 ? _c('AddFieldButton', {
    on: {
      "addMulti": function ($event) {
        return _vm.addField('multi');
      },
      "addText": function ($event) {
        return _vm.addField('text');
      },
      "addTextArea": function ($event) {
        return _vm.addField('text-area');
      }
    }
  }) : _vm._e()], 1)], 1) : _c('div', [_c('div', {
    staticClass: "mb-5 md:mb-15 2xl:mb-20"
  }, [_c('h3', [_vm._v("\n        " + _vm._s(this.infosPage.libelle_template) + "\n      ")])]), _vm._v(" "), _c('list-buttons', {
    attrs: {
      "evaluation-in-progress": _vm.evaluationInProgress,
      "is-active": _vm.infosPage.is_active,
      "can-delete": false
    },
    on: {
      "assignTemplate": function ($event) {
        return _vm.displayAssignTemplate();
      },
      "preview": function () {
        _vm.showPreview = true;
      },
      "deactivateTemplate": function ($event) {
        return _vm.displayConfirmDeactivateTemplate();
      },
      "activateTemplate": function ($event) {
        return _vm.displayConfirmActivateTemplate();
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mx-15"
  }, [_c('h3', {
    staticClass: "text-lg text-gray-600"
  }, [_vm._v("\n        Le modèle de page " + _vm._s(this.infosPage.libelle_template) + " n'est pas\n        modifiable."), _c('br'), _vm._v("\n        Vous pouvez simplement\n        "), _vm.$can(_vm.constants.PERMISSION_MODELE_DE_PAGE_DESACTIVER) ? _c('span', [_vm._v("activer ou désactiver")]) : _c('span', [_vm._v("visualiser")]), _vm._v(" le modèle de page.\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "my-15 flex justify-center"
  }, [_c('illustration', {
    attrs: {
      "name": "notAllowed"
    }
  })], 1)])], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }